import React from 'react';
import { Outlet } from 'react-router-dom';

function ConversationsPage() {
  return <Outlet />;
}

export default ConversationsPage;
